/** Mirrors the backend `HookParamType`. */
export enum ReflectionParamTypeEnum {
  FIELD_KEY = 'field_key',
  FIELD_KEY_LIST = 'field_key_list',
  ENUM = 'enum',
  MULTI_ENUM = 'multi_enum',
  TEXT = 'text',
  LOCALIZED_TEXT = 'localized_text',
  NUMBER = 'number',
  BOOL = 'bool',
  FLOW_TEMPLATE = 'flow_template',
  USER_LIST = 'user_list',
  RECIPIENTS = 'recipients',
  URL = 'url',
  SECRET = 'secret',
  MAP = 'map',
}
